import {h, Fragment} from "preact"
import { useFacets, useProductFilters, useSort, useAppStateSelector, pick } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import SelectedFilters from "./SelectedFilters"
import Select from "./elements/Select"
import { sortOptions } from "../config"
import {isDesktop, closeSidebar} from "../helpers"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            {/* <Icon name="close" /> */}
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </path>
            </svg>
        </label>
    )
}

export default function SideBar() {
    const { query, response, pageType } = useAppStateSelector(state =>
        pick(state, "query", "response", "pageType")
    )
    const { loading, facets } = useFacets();
    const { filters, removeAll } = useProductFilters();
    const { activeSort, setSort } = useSort(sortOptions);

    const handleSortChange = event => {
        setSort(event.target.value)
    }
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }));
    const docCount = response.products?.total ?? 0
    const totalSummary = `${docCount} products`;

    const isSearch = pageType === "search";

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-d-none"
                for={toggleButtonId}
            />
            <div
            // ns-col-3 ns-col-l-2
                class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100"
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-justify-content-between">
                        <span class="ns-font-4 ns-uppercase">{isSearch ? 'Refine by' : isDesktop ? 'Filters' : 'Filter and Sort'}</span>
                        <p class="mobile-facets__count">{totalSummary}</p>
                        <ToggleSidebarButton />
                        {filters?.length > 0 && (
                            <span
                                class={`ns-anchor ns-text-align-right ns-font-1 ns-clear-all-filters ns-in-sidebar`}
                                onClick={() => {
                                    removeAll()
                                }}
                            >
                               {isSearch ? 'Clear All' : 'Remove all'}
                            </span>
                        )}
                    </div>
                    <SelectedFilters isSearch={isSearch} isSidebar />
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} isDesktop={isDesktop} isSearch={isSearch}/>
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} isSearch={isSearch}/>
                                    default:
                                        return null
                                }
                            })}
                            {!isSearch && <li>
                                <Select 
                                    value={activeSort}
                                    onChange={e => handleSortChange(e)}
                                    className="ns-selection-dropdown-sort-menu"
                                    options={options}
                                    label={"Sort by"}
                                />
                            </li>}
                        </ul>
                    </div>
                </div>
                {isSearch && !isDesktop ? (
                    <div class="nosto__filter-tree-vertical-show-result">
                        <button type="button" aria-label="Show result" class="nosto__button nosto__button--result" onClick={()=>closeSidebar()}>
                            <span class="nosto__button-text">Show result ({docCount})</span>
                        </button>
                    </div>
                ) : (
                    <div class="mobile-facets__footer">
                        <span
                            class={`ns-anchor ns-text-align-right ns-font-1 ns-clear-all-filters ns-in-sidebar`}
                            onClick={() => {
                                removeAll()
                            }}
                        >
                            Remove all
                        </span>
                        <button type="button" class="no-js-hidden button button--primary" onClick={()=>closeSidebar()}>
                            Apply
                        </button>
                    </div>
                )}
            </div>
        </>
    ) : (
        ""
    )
}
